module.exports = __webpack_public_path__ + "img/absapay.f793caaa.svg";